<template>
  <nav-header />
  <u-main class="h-vh">
    <slot></slot>
  </u-main>
  <nav-footer />
</template>
<script setup lang="ts">
import NavHeader from "~/components/local/nav-header.vue";
import NavFooter from "~/components/local/nav-footer.vue";
</script>
